import * as z from "zod/v4";
import {
  SemanticQueryCastTypeSchema,
  type SemanticQueryTableName,
} from "./semantic-query-primitives";

export const trimStringInput = (value: unknown) =>
  typeof value === "string" ? value.trim() : value;

const RawSqlIdentifierSchema = z
  .string()
  // Keep identifiers to ordinary SQL-safe names. User-facing labels use
  // OutputAliasSchema below and are quoted separately by the Snowflake compiler.
  .regex(/^[a-zA-Z_][a-zA-Z0-9_]*$/)
  .max(64);

export const SqlIdentifierSchema = z.preprocess(
  trimStringInput,
  RawSqlIdentifierSchema,
);

export const OutputAliasSchema = z.string().min(1).max(120);

export const NullableSqlIdentifierSchema = z.union([
  SqlIdentifierSchema,
  z.null(),
]);

export const NullableOutputAliasSchema = z.union([OutputAliasSchema, z.null()]);

export const TrimmedSemanticQueryCastTypeSchema = z.preprocess(
  trimStringInput,
  SemanticQueryCastTypeSchema,
);

export const DefaultTableAliases: Record<SemanticQueryTableName, string> = {
  orders: "ord",
  order_customer_classifications: "occ",
  return_facts: "rf",
  return_compensation_methods: "rcm",
  return_order_facts: "rof",
  return_order_line_items: "roli",
  merchant_line_items: "mli",
  order_product_reports: "opr",
  return_line_items: "rli",
  return_product_reports: "rpr",
  returns: "ret",
  return_reports: "rr",
};

export const SemanticAggregateFnSchema = z.enum([
  "count",
  "count_distinct",
  "count_if",
  "sum",
  "avg",
  "min",
  "max",
  "any_value",
]);

export const SemanticSourceModeSchema = z.enum(["report_tables", "raw_tables"]);

export type SemanticSourceMode = z.infer<typeof SemanticSourceModeSchema>;

export const DEFAULT_SEMANTIC_SOURCE_MODE: SemanticSourceMode = "report_tables";
